module.exports = __webpack_public_path__ + "static/media/FeedTime_ios_2.047452c1.jpg";